/*
 * @Author: Chao Yang
 * @Date: 2020-01-17 09:40:31
 * @LastEditor: Chao Yang
 * @LastEditTime : 2020-01-17 09:57:54
 */
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CancelService } from 'src/app/infrastructure/service';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class Cancel implements HttpInterceptor {
  constructor(private _cancelService: CancelService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(req)
      .pipe(takeUntil(this._cancelService.onCancelPendingRequests()));
  }
}
